/**
 * Copied from dashboard
 */

import { notEmpty } from "./typeHelpers";

type ConnectionCursor = string;

type Edge<Node> = {
  node: Node | null;
  cursor?: ConnectionCursor | null;
} | null;

type PageInfo = {
  startCursor?: ConnectionCursor | null;
  endCursor?: ConnectionCursor | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};

export type Connection<Node> =
  | {
      edges: Array<Edge<Node>> | null;
      pageInfo?: PageInfo;
    }
  | null
  | undefined;

export const connectionToNodes = <Node>(connection: Connection<Node>) =>
  connection && connection.edges
    ? connection.edges.map((x) => x?.node).filter(notEmpty)
    : [];
